import { useEffect, useState } from "react";

export function useSessionFilters<T extends object>(
  storageKey: string | undefined,
  defaults: T,
): [T, React.Dispatch<React.SetStateAction<T>>] {
  const [state, setState] = useState<T>(() => {
    if (!storageKey || typeof window === "undefined") return defaults;
    try {
      const raw = window.sessionStorage.getItem(storageKey);
      if (raw) return { ...defaults, ...(JSON.parse(raw) as Partial<T>) };
    } catch {
      /* ignore */
    }
    return defaults;
  });

  useEffect(() => {
    if (!storageKey || typeof window === "undefined") return;
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(state));
    } catch {
      /* ignore */
    }
  }, [storageKey, state]);

  return [state, setState];
}
